// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2b2wK","buttons":"SendReceipts_buttons__1t9RI","email":"SendReceipts_email__1O5Np","bookApptTitle":"SendReceipts_bookApptTitle__lyvsd"};